<template>
  <div class="searchGood-container">
    <div class="search-filter" ref="searchFilterRef" :class="isShowOpen ? 'filter-more' : ''">
      <!-- 价格区间 -->
      <div class="filter-common filter-price">
        <div class="left">价格区间</div>
        <div class="right">
          <el-input size="mini" v-model="minPrice" placeholder="最低价"></el-input>
          <span>-</span>
          <el-input size="mini" v-model="maxPrice" placeholder="最高价"></el-input>
          <el-button size="mini" @click="handleSelectPrice">确定</el-button>
        </div>
      </div>
      <!-- 品牌 -->
      <div class="filter-common filter-brand">
        <div class="left">品牌</div>
        <div class="right">
          <div
            class="brandName"
            :class="brand.brandId === brandId ? 'brandActive' : ''"
            v-for="brand of brandList"
            :key="brand.brandId"
            @click="handleSelectedBrand(brand)"
          >{{ brand.brandName }}</div>
        </div>
      </div>
      <!-- 属性 -->
      <div
        class="filter-common filter-attribute"
        v-for="attribute of attributeList"
        :key="attribute.keyId"
      >
        <div class="left">{{ attribute.attributeName }}</div>
        <div class="right">
          <div 
            class="attribute-value"
            :class="valueIds.includes(value.valueId) ? 'valueActive' : ''"
            v-for="value of attribute.values"
            :key="value.valueId"
            @click="handleSelectValue(value)"
          >{{ value.attributeValue }}</div>
        </div>
      </div>
      <div v-if="isShowMore" class="look-more">
        <span @click="handleChangeShowMore">
          {{ isShowOpen ? "收起" : "更多选项"}}
          <el-icon v-if="!isShowOpen" class="el-icon-arrow-down"></el-icon>
          <el-icon v-else class="el-icon-arrow-up"></el-icon>
        </span>
      </div>
    </div>
    <div class="search-sort">
      <div class="sort-overall" :class="activeTab === 'marketTime' ? 'activeSort' : ''" @click="handleSortOverall('marketTime')">
        综合
      </div>
      <div class="sortWrap">
        <p 
          :class="(activeTab === 'descNew' || activeTab === 'ascNew') ? 'activeSort' : ''" 
          @click="priceSort('new')"
        >最新
          <i class="el-icon-caret-top" :class="activeTab === 'ascNew' ? 'activeSort' : ''"></i>
          <i class="el-icon-caret-bottom" :class="activeTab === 'descNew' ? 'activeSort' : ''"></i>
        </p>
        <p 
          :class="(activeTab === 'descPrice' || activeTab === 'ascPrice') ? 'activeSort' : ''" 
          @click="priceSort('price')"
        >价格
          <i class="el-icon-caret-top" :class="activeTab === 'ascPrice' ? 'activeSort' : ''"></i>
          <i class="el-icon-caret-bottom" :class="activeTab === 'descPrice' ? 'activeSort' : ''"></i>
        </p>
      </div>
      <div class="sort-brand" :class="activeTab === 'brandId' ? 'activeSort' : ''" @click="handleSortBrand('brandId')">
        品牌
      </div>
    </div>
    <div class="good-list">
      <div class="goodItem" v-for="good of goodList" :key="good.commodityId" @click="handleGoodDetail(good)">
        <div class="img">
          <img :src="getCommodityImg(good)" alt="">
          <img v-if="Number(good.reserve) === 0" class="soldOut1" src="@/assets/images/pt-soldOut.png" alt="">
        </div>
        <div class="info">
          <div>
            <div class="storeCommodity">
              <img class="UImg" v-if="good.storeType === 'U'" src="@/assets/images/pt-yxdp.png" alt="">
              <img class="SImg" v-if="good.storeType === 'S'" src="@/assets/images/pt-yxdp.png" alt="">
              <div class="commodityName">{{ good.commodityName }}</div>
            </div>
            <div class="commodityTag">
              <span class="tag" v-for="tag of good.tags" :key="tag.tagId">{{ tag.tagName }}</span>
            </div>
          </div>
          
          <div class="price">
            <span class="retail" v-if="good.pays[0].payType === 1">
              <span class="symbol">¥</span>{{ getRetailPriceMin(good).retailPrice }}
            </span>
            <span class="retail" v-if="good.pays[0].payType === 2">
              {{ getRetailPriceMin(good).retailPrice }}&nbsp;提货值
            </span>
            <span class="original" v-if="good.pays[0].payType === 1">
              <span class="symbol">¥</span>{{ getRetailPriceMin(good).skuPrice }}</span>
            <span class="original" v-if="good.pays[0].payType === 2">
              {{ getRetailPriceMin(good).skuPrice }}&nbsp;提货值
            </span>
            <span class="sold">已售{{ good.salesNumber }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="noMore" v-show="goodList.length <= 0">
      暂无数据
    </div>
    <!-- 分页 -->
    <el-row v-if="pageData.total" style="margin-top:10px">
      <el-col :span="24" class="paginateWrap">
        <el-pagination
          popper-class="_popStyle"
          :current-page="pageData.currentPage"
          :page-sizes="pageData.pageSizes"
          :page-size="pageData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageData.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/*global protocol http */
import { mapState, mapMutations } from 'vuex'
export default {
  data() {
    return {
      currentSearchStatus: 1, // 1-搜索框搜索(包括排序) 2-筛选搜索
      activeTab: '',
      sort: [{direction: "DESC", property: "sortId"}], // 默认综合排序
      goodList: [],
      searchInfo: '',
      // 分页相关
      pageData: {
        total: null,
        pageSizes: [8, 16, 32, 64],
        pageSize: 16,
        currentPage: 1
      },
      isNetWrong: true,
      attributeList: [], // 属性列表
      brandList: [], // 品牌列表
      isShowOpen: false, // 是否查看更多
      isShowMore: false, // 是否展示查看更多按钮
      brandId: null,
      maxPrice: null,
      minPrice: null,
      valueIds: [],
      classId: null
    }
  },
  computed: {
    ...mapState('pt', ['currentSearchInfo', 'currentSearchClassId'])
  },
  mounted() {
    this.$nextTick(() => {
      this.searchInfo = this.currentSearchInfo
      this.classId = this.currentSearchClassId
      this.loadData()
      this.$emit('setSearchInfo', this.currentSearchInfo)
    })
  },
  methods: {

    // 跳转商品详情页
    handleGoodDetail(good) {
      this.$router.push({
        name: 'ptOrdinaryGoodDetail',
        query: {
          commodityId: good.commodityId,
          storeId: good.storeId,
        }
      })
    },

    // 选择价格区间
    handleSelectPrice() {

      if (Number(this.maxPrice) < Number(this.minPrice)) {
        this.$message('最高价不能低于最低价')
        return
      }

      if (isNaN(Number(this.minPrice)) || isNaN(Number(this.maxPrice))) {
        this.$message('请输入有效的数字')
        return
      }
      if (!this.minPrice && this.maxPrice) {
        this.$message('请输入最低价')
        return
      } 
      if (!this.maxPrice && this.minPrice) {
        this.$message('请输入最高价')
        return
      }
      this.queryGoodByFilter()
    },
    // 选择品牌
    handleSelectedBrand(brand) {
      if (Number(this.brandId) === Number(brand.brandId)) {
        this.brandId = null
        this.queryGoodByFilter()
        return
      }
      this.brandId = Number(brand.brandId)
      this.queryGoodByFilter()
    },
    // 选择属性值
    handleSelectValue(value) {
      if (this.valueIds.includes(Number(value.valueId))) {
        const index = this.valueIds.indexOf(Number(value.valueId))
        this.valueIds.splice(index, 1)
        this.queryGoodByFilter()
        return
      }
      this.valueIds.push(Number(value.valueId))
      this.queryGoodByFilter()
    },
    // 综合 和 品牌 排序
    handleSortOverall(type) {
      this.currentSearchStatus = 1 // 切换为搜索框搜索
      if (this.activeTab === type) {
        this.activeTab = ''
        this.sort = [{
          direction: 'DESC',
          property: 'sortId'
        }]
      } else {
        this.activeTab = type
        this.sort = [{
          direction: 'DESC',
          property: type
        }]
      }
      this.loadData2()
    },
    handleSortBrand(type) {
      this.currentSearchStatus = 1 // 切换为搜索框搜索
      if (this.activeTab === type) {
        this.activeTab = ''
        this.sort = [{
          direction: 'DESC',
          property: 'sortId'
        }]
      } else {
        this.activeTab = type
        this.sort = [{
          direction: 'DESC',
          property: type
        }]
      }
      this.loadData2()
    },
    // 最新 和 价格 排序
    priceSort(type) {
      this.currentSearchStatus = 1 // 切换为搜索框搜索
      if (this.activeTab === 'descNew' || this.activeTab === 'descPrice') {
        this.activeTab = ''
        this.sort = [{
          'direction': 'DESC',
          'property': 'sortId'
        }]
        this.loadData2()
        return
      }
      if (type === 'new') {
        if (this.activeTab === 'ascNew') {
          this.activeTab = 'descNew'
          this.sort = [{
            'direction': 'DESC',
            'property': 'sortId'
          }]
        } else {
          this.activeTab = 'ascNew'
          this.sort = [{
            'direction': 'ASC',
            'property': 'sortId'
          }]
        }
      } else {
        if (this.activeTab === 'ascPrice') {
          this.activeTab = 'descPrice'
          this.sort = [{
            'direction': 'DESC',
            'property': 'minPrice'
          }]
        } else {
          this.activeTab = 'ascPrice'
          this.sort = [{
            'direction': 'ASC',
            'property': 'minPrice'
          }]
        }
      }
      this.loadData2()
    },
    handleChangeShowMore() {
      this.isShowOpen = !this.isShowOpen
    },
    // 提取商品主图
    getCommodityImg(commodity) {
      return commodity.imgs.find(img => Number(img.isMain) === 1).img
    },
    // 提取零售价(所有规格的最低价格)
    getRetailPriceMin(commodity) {
      let minObj = commodity.skus[0]
      commodity.skus.forEach(sku => {
        if (Number(sku.retailPrice) < Number(minObj.retailPrice) && Number(sku.display) === 1) {
          minObj = sku
        }
      })
      return minObj
    },

    // 通过筛选条件过滤
    queryGoodByFilter() {
      // if (
      //   !this.brandId &&
      //   !this.maxPrice &&
      //   !this.minPrice &&
      //   !this.valueIds.length
      // ) {
      //   this.loadData()
      //   return
      // }
      this.activeTab = null
      this.currentSearchStatus = 2 // 切换为搜索框搜索
      const apiObj = JSON.parse(JSON.stringify(protocol.param_pt_queryAttributeCommodityIds))
      apiObj.param = {
        page: this.pageData.currentPage - 1,
        size: this.pageData.pageSize,
        commodityName: this.searchInfo,
        brandId: this.brandId,
        maxPrice: this.maxPrice,
        minPrice: this.minPrice,
        valueIds: this.valueIds,
        classId: this.classId,
        level: 3,
        sort: [{direction: "DESC", property: "sortId"}],
      }
      http.postFrontMall(apiObj).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          this.pageData.total = value.totalElements
          this.isNetWrong = false
          this.goodList = value.content
        } else {
          this.$message(message)
          this.isNetWrong = true
          this.goodList = []
        }
      })
    },

    loadData() {
      // 重置过滤内容
      this.brandId = null,
      this.maxPrice = null,
      this.minPrice = null,
      this.valueIds = []
      this.isShowOpen = false
      this.currentSearchStatus = 1 // 切换为搜索框搜索
      this.$nextTick(() => {
        // 查询商品
        this.queryGoodByCommodityName()
        // 查询所有属性
        this.queryAttributeByCommodityName()
        // 查询所有品牌
        this.queryBrandByCommodityName()
      })
    },
    loadData2() {
      // 重置过滤内容
      this.brandId = null,
      this.maxPrice = null,
      this.minPrice = null,
      this.valueIds = []
      this.isShowOpen = false
      this.currentSearchStatus = 1 // 切换为搜索框搜索
      this.$nextTick(() => {
        // 查询商品
        this.queryGoodByCommodityName()
        // 查询所有属性
        this.queryAttributeByCommodityName()
        // 查询所有品牌
        this.queryBrandByCommodityName()
      })
    },
    // 通过商品名称模糊搜索商品
    queryGoodByCommodityName() {
      const apiObj = JSON.parse(JSON.stringify(protocol.param_pt_queryCommodity))
      apiObj.param = {
        sort: this.sort && this.sort.length ? this.sort : [{direction: "DESC", property: "sortId"}],
        page: this.pageData.currentPage - 1,
        size: this.pageData.pageSize,
        commodityName: this.searchInfo,
        classId: this.classId,
        level: 3
      }
      http.postFrontMall(apiObj).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          this.pageData.total = value.totalElements
          this.isNetWrong = false
          this.goodList = value.content
        } else {
          this.$message(message)
          this.isNetWrong = true
          this.goodList = []
        }
      })
    },
    // 通过商品名称模糊查询属性
    queryAttributeByCommodityName() {
      const apiObj = JSON.parse(JSON.stringify(protocol.param_pt_queryAttributeLikeCommodityName))
      apiObj.param = {
        commodityName: this.searchInfo,
        page: 0,
        size: 99999,
        level: 3,
        classId: this.classId
      }
      http.postFrontMall(apiObj).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          this.attributeList = value
          this.$nextTick(() => {
            this.isShowMore = this.$refs.searchFilterRef.scrollHeight > this.$refs.searchFilterRef.offsetHeight
          })
        } else {
          this.$message(message)
          this.attributeList = []
        }
      })
    },
    // 通过商品名称模糊查询品牌
    queryBrandByCommodityName() {
      const apiObj = JSON.parse(JSON.stringify(protocol.param_pt_queryBrandLikeCommodityName))
      apiObj.param = {
        commodityName: this.searchInfo,
        page: 0,
        size: 99999,
        level: 3,
        classId: this.classId
      }
      http.postFrontMall(apiObj).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          this.brandList = value.content
        } else {
          this.$message(message)
          this.brandList = []
        }
      })
    },
    handleSizeChange(val) {
      this.pageData.pageSize = val
      if (this.currentSearchStatus === 1) {
        this.queryGoodByCommodityName()
      } else {
        this.queryGoodByFilter()
      }
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      if (this.currentSearchStatus === 1) {
        this.queryGoodByCommodityName()
      } else {
        this.queryGoodByFilter()
      }
    },
  }
}
</script>
<style scoped lang="scss">
  .searchGood-container {
    color: #000000;
    margin: 0 auto 20px;
    width: 1200px;
    .search-filter {
      width: 100%;
      background: #ffffff;
      border-radius: 4px 4px 0 0;
      padding: 23px 17px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      gap: 30px;
      overflow: hidden;
      max-height: 320px;
      position: relative;
      &.filter-more {
        max-height: none;
        padding-bottom: 50px;
      }
      // 筛选区域
      .filter-common {
        display: flex;
        font-size: 16px;
        .left {
          width: 125px;
        }
        .right {
          flex: 1;
        }
        // 价格区间
        &.filter-price {
          .left {}
          .right {
            display: flex;
            align-items: center;
            gap: 10px;
            /deep/.el-input {
              width: 100px;
            }
            /deep/.el-button {
              background: #1571DB;
              color: #ffffff;
              border-radius: 5px;
            }
          }
        }
        // 品牌
        &.filter-brand {
          .left {}
          .right {
            display: flex;
            gap: 20px;
            flex-wrap: wrap;
            .brandName {
              cursor: pointer;
              user-select: none;
              width: fit-content;
              white-space: nowrap;
              background: #f4f4f4;
              height: 30px;
              width: fit-content;
              line-height: 30px;
              padding: 0 10px;
              border-radius: 30px;
              &.brandActive {
                background: #1571DB;
                color: #ffffff;
              }
            }
          }
        }
        // 属性
        &.filter-attribute {
          .left {}
          .right {
            display: flex;
            gap: 20px;
            flex-wrap: wrap;
            .attribute-value {
              cursor: pointer;
              user-select: none;
              width: fit-content;
              white-space: nowrap;
              background: #f4f4f4;
              height: 30px;
              width: fit-content;
              line-height: 30px;
              padding: 0 10px;
              border-radius: 30px;
              &.valueActive {
                background: #1571DB;
                color: #ffffff;
              }
            }
          }
        }
      }
      .look-more {
        user-select: none;
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        height: 50px;
        text-align: center;
        box-sizing: border-box;
        background: linear-gradient(to bottom, 
        rgba(255, 255, 255, 0) 0%, 
        rgba(255, 255, 255, 0.5) 30%, 
        rgba(255, 255, 255, 0.8) 70%, 
        rgba(255, 255, 255, 1) 100%
        );
        span {
          cursor: pointer;
          font-size: 14px;
          line-height: 50px;
          display: inline-block;
          height: 100%;
        }
      }
    }
    // 排序
    .search-sort {
      width: 100%;
      height: 40px;
      background: #ffffff;
      margin-top: 20px;
      display: flex;
      gap: 34px;
      align-items: center;
      font-size: 16px;
      padding: 0 17px;
      box-sizing: border-box;
      // 综合排序
      .sort-overall {
        line-height: 16px;
        user-select: none;
        cursor: pointer;
        &.activeSort{
          color: #1571DB;
        }
      }
      // 最新 和 价格 排序
      .sortWrap {
        display: flex;
        align-items: center;
        user-select: none;
        gap: 40px;
        p {
          // margin-right: 24px;
          font-size: 16px;
          font-weight: 400;
          line-height: 16px;
          position: relative;
          cursor: pointer;
        }
        /deep/.el-icon-caret-top {
          position: absolute;
          font-size: 10px;
          top: -1px;
          color: #999999;
        }
        /deep/.el-icon-caret-bottom{
          position: absolute;
          font-size: 10px;
          bottom: -1px;
          color: #999999;
        }
        .activeSort{
          color: #1571DB;
        }
      }
      .sort-brand {
        line-height: 16px;
        user-select: none;
        cursor: pointer;
        &.activeSort{
          color: #1571DB;
        }
      }
    }
    // 商品列表
    .good-list {
      margin-top: 20px;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      gap: 21px;
      .goodItem {
        cursor: pointer;
        width: 284px;
        height: 380px;
        background: #FFFFFF;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .img {
          width: 100%;
          height: 282px;
          background: #E4E4E4;
          position: relative;
          img {
            width: 100%;
            height: 100%;
          }
          .soldOut1 {
            position: absolute;
            top: 0;
            left: 0;
            transform: scale(0.7);
          }
        }
        .info {
          flex: 1;
          padding: 10px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .storeCommodity {
            display: flex;
            align-items: center;
            gap: 6px;
            img {
              height: 16px;
            }
            .commodityName {
              font-size: 14px;
              color: #333333;
              flex: 1;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .commodityTag {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            gap: 6px;
            margin-top: 7px;
            .tag {
              color: #ED732E;
              font-size: 10px;
              border: 1px solid #ED732E;
              padding: 0 2px;
            }
          }
          .price {
            font-size: 14px;
            .retail {
              color: #333333;
              .symbol {
                color: #333333;
                font-size: 10px;
              }
            }
            .original {
              text-decoration: line-through;
              color: #cccccc;
              font-size: 10px;
              .symbol {
                color: #cccccc;
                font-size: 10px;
              }
            }
            .sold {
              font-size: 12px;
              color: #999999;
              margin-left: 5px;
            }
          }
        }
      }
    }
    .noMore {
      color: #333333;
      font-size: 18px;
      font-weight: 500;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }
    /deep/ .el-pagination {
      .el-input {
        .el-input__inner {
          background: #ffffff;
        }
      }
    }
  }
</style>